export default {
  apiKey: 'AIzaSyDYNZkL3EiGOFOhccK-xTFC_Mf0lwbZJFE',
  authDomain: 'timac-agro-espaa.firebaseapp.com',
  projectId: 'timac-agro-espaa',
  storageBucket: 'timac-agro-espaa.firebasestorage.app',
  messagingSenderId: '25805312051',
  appId: '1:25805312051:web:6c0ecc0e1ff64f03ed9346',
  measurementId: 'G-QG4JS095S2',
};
